import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=801a84fc&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "801a84fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('801a84fc')) {
      api.createRecord('801a84fc', component.options)
    } else {
      api.reload('801a84fc', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=801a84fc&scoped=true&", function () {
      api.rerender('801a84fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2d2e2SgEypq8J/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports